import axios from 'axios'
import { datadogLogs } from '@datadog/browser-logs'
import { coreRespondentUrl } from 'utils/coreRespondentUrl'
import { useQuestionnaireParams } from './useQuestionnaireParams'

interface FileUploadUrlResponse {
  upload_url: string
  object_ref: string
  expires_at: string
}

const useUploadRespondentFile = () => {
  const mandatoryQueryParams = useQuestionnaireParams()

  return async (file: File, questionId: string): Promise<string> => {
    const baseUrl = coreRespondentUrl(
      `/surveys/${mandatoryQueryParams.surveyId}/respondents/supplier/${mandatoryQueryParams.respondentId}/file-upload-url`
    )
    const issueUrl = `${baseUrl}?panel_supplier_code=${encodeURIComponent(
      mandatoryQueryParams.panelSupplier
    )}`

    let signed: FileUploadUrlResponse
    try {
      const response = await axios.post<FileUploadUrlResponse>(issueUrl, {
        question_id: questionId,
        filename: file.name,
        content_type: file.type
      })
      signed = response.data
    } catch (err) {
      datadogLogs.logger.error('Failed to issue respondent file-upload URL', {
        err,
        questionId,
        filename: file.name,
        contentType: file.type
      })
      throw err
    }

    try {
      await axios.put(signed.upload_url, file, {
        headers: { 'Content-Type': file.type }
      })
    } catch (err) {
      datadogLogs.logger.error('Failed to PUT respondent file to GCS', {
        err,
        questionId,
        objectRef: signed.object_ref
      })
      throw err
    }

    return signed.object_ref
  }
}

export default useUploadRespondentFile
